import React, { useEffect } from 'react';
import Typography from 'components/Typography/Typography';
import useEmblaCarousel from 'embla-carousel-react';
import { MiniCard } from './MiniCard/MiniCard';
import { MiniCardButtonLabelsProps } from './RecommendStripUI.types';
import {
  usePrevNextButtons,
  Arrow,
  ArrowDirection,
} from './SliderArrows/SliderArrows';
import { ProductSearchMaterial } from '../../pages/ProductSearch/types';
export interface RecommendStripUiProps {
  title?: string;
  materials: ProductSearchMaterial[];
  cardButtonsLabels?: MiniCardButtonLabelsProps;
  cartLoadingIds?: string[];
  activeItemId?: string;
  showSecondaryActionButton?: boolean;
  onAddToCart: (product: ProductSearchMaterial) => void;
  onCardClick: (product: ProductSearchMaterial) => void;
}

export const RecommendStripUI: React.FC<RecommendStripUiProps> = ({
  title,
  materials,
  cardButtonsLabels,
  cartLoadingIds = [],
  activeItemId,
  showSecondaryActionButton = false,
  onAddToCart,
  onCardClick,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    slidesToScroll: 'auto',
  });
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.scrollTo(0);
    }
  }, [emblaApi, materials]);

  return (
    <div
      className="flex flex-column w-full relative py-3"
      style={containerStyle}
    >
      {title != null && (
        <Typography
          variant="h3"
          fontWeight="bold"
          padding="1em 0"
          className="cursor-pointer"
          sx={titleSx}
        >
          {title}
        </Typography>
      )}
      <div className="flex relative w-full">
        <Arrow
          direction={ArrowDirection.LEFT}
          onClick={onPrevButtonClick}
          show={!prevBtnDisabled}
        />
        <Arrow
          direction={ArrowDirection.RIGHT}
          onClick={onNextButtonClick}
          show={!nextBtnDisabled}
        />
        <div ref={emblaRef} className="w-full overflow-hidden">
          <div className="flex gap-3">
            {materials?.map((product: ProductSearchMaterial) => (
              <MiniCard
                isSelected={activeItemId === String(product?.entityId)}
                key={product?.entityId}
                product={product}
                cardButtonsLabels={cardButtonsLabels}
                showSecondaryActionButton={showSecondaryActionButton}
                onAddToCart={onAddToCart}
                onCardClick={onCardClick}
                isAddToCartLoading={cartLoadingIds?.includes(
                  String(product?.entityId),
                )}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/////
const containerStyle = {
  minHeight: '140px',
};

const titleSx = {
  '@media (max-width: 768px)': {
    fontSize: '18px',
    lineHeight: '24px',
  },
};
